import type { IUsershipTag } from '@root/query/constants'
import { FaUserTag, FaUserTie } from 'react-icons/fa'
import type { IconType } from 'react-icons'

export const ENTREPRENEUR_TAG = 'entrepreneur'

const BUSINESS_ROLE_ICONS: Record<string, IconType> = {
  [ENTREPRENEUR_TAG]: FaUserTie
}

export const getBusinessRoleIcon = (id?: string) => BUSINESS_ROLE_ICONS[id ?? ''] ?? FaUserTag

export const roleById = (roles: IUsershipTag[] | undefined, id: string): IUsershipTag =>
  roles?.find(role => role.id === id) ?? {
    id,
    name: id,
    plural: id,
    description: ''
  }
